import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea.tsx';
import { SharedBottomModuleSpacer } from './SharedBottomModuleSpacer.jsx';
import { SharedBottomModuleContent } from './SharedBottomModuleContent.jsx';

const SharedBottomModuleComponent = ({ bottomModule, className }) => {
    return (
        <SharedBottomModuleSpacer className={className} bottomModule={bottomModule}>
            <ExpandingAreaWithReadMore collapsedHeight={165}>
                <SharedBottomModuleContent bottomModule={bottomModule} />
            </ExpandingAreaWithReadMore>
        </SharedBottomModuleSpacer>
    );
};

SharedBottomModuleComponent.propTypes = {
    bottomModule: PropTypes.array,
    className: PropTypes.string,
};

export const SharedBottomModule = createFragmentContainer(SharedBottomModuleComponent, {
    bottomModule: graphql`
        fragment SharedBottomModule_bottomModule on BottomModule @relay(plural: true) {
            ...SharedBottomModuleContent_bottomModule
        }
    `,
});
